import axios from "axios";
import { LOGIN } from '../config/urlConfig'


// Function for handling Login api 
export async function login(userData){
    try{

        let response =  await  axios.post(LOGIN,userData)
        return response.data;
    }catch(error){

       if(error?.response){
        return error.response.data;
       }
       console.log(error.message);
    }   
}